document.addEventListener("DOMContentLoaded", () => {
  const fixedLivePreview = () => {
    const galleryWrapperSelector = ".grid__item.product__media-wrapper";
    const $galleryWrapper = document.querySelector(galleryWrapperSelector);
    if (!$galleryWrapper) return;

    /* ------------------------------------------------------------
       1) Dynamic sticky header offset
       ------------------------------------------------------------ */
    const setStickyHeaderHeightVar = () => {
      const header =
        document.querySelector("header.header") ||
        document.querySelector(".shopify-section-header") ||
        document.querySelector("#shopify-section-header") ||
        document.querySelector(".header-wrapper");

      const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty("--sticky-header-height", `${height}px`);
    };

    setStickyHeaderHeightVar();
    window.addEventListener("resize", setStickyHeaderHeightVar);

    const getHeaderOffset = () =>
      parseInt(
        getComputedStyle(document.documentElement).getPropertyValue("--sticky-header-height"),
        10
      ) || 0;

    /* ------------------------------------------------------------
       2) Inject CSS
       ------------------------------------------------------------ */
    const style = document.createElement("style");
    style.innerHTML = `
      /* Sticky preview container ONLY when active */
      body.gallery--sticky-active ${galleryWrapperSelector} .tee-gallery-content {
        background: #fff;
        box-shadow: 0 2px 5px 3px rgba(0,0,0,.15);
        display: flex;
        justify-content: center;

        position: fixed;
        top: var(--sticky-header-height, 0px);

        left: 50%;
        width: 100vw;
        transform: translateX(-50%);
        will-change: transform;

        z-index: 99;
      }

      body.gallery--sticky-active ${galleryWrapperSelector} .tee-gallery {
        width: 100%;
        transform: none;
      }

      /* Hide thumbnail strip / dots in sticky mode */
      body.gallery--sticky-active ${galleryWrapperSelector} .tee-thumbnails,
      body.gallery--sticky-active ${galleryWrapperSelector} .tee-slider__dots {
        display: none !important;
      }

      /* Safety override: when NOT active, force normal positioning */
      body.gallery--sticky-enabled:not(.gallery--sticky-active) ${galleryWrapperSelector} .tee-gallery-content {
        position: static !important;
        top: auto !important;
        left: auto !important;
        width: auto !important;
        transform: none !important;
        will-change: auto !important;
        box-shadow: none !important;
      }

      /* Trigger wrapper */
      .sticky-gallery-trigger {
        position: fixed;
        right: 20px;
        top: calc(var(--sticky-header-height, 0px) + 24px);
        z-index: 999;

        display: none;
        flex-direction: column;
        align-items: center;
        gap: 6px;
      }

      /* Show trigger only when enabled AND not active */
      body.gallery--sticky-enabled:not(.gallery--sticky-active) .sticky-gallery-trigger {
        display: flex;
      }

      /* Force button visible even if older CSS contains display:none */
      body.gallery--sticky-enabled:not(.gallery--sticky-active) .sticky-gallery-trigger .sticky-gallery-button {
        display: flex !important;
      }

      .sticky-gallery-trigger .sticky-gallery-button {
        width: 52px;
        height: 52px;
        border-radius: 999px;

        background-color: #F4B13D;
        background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="black"><path d="M21 3H3c-1.1 0-2 .9-2 2v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14z"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21h16z"/></svg>');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 22px 22px;

        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        cursor: pointer;

        align-items: center;
        justify-content: center;
        line-height: 0;
      }

      .sticky-gallery-trigger .sticky-gallery-label {
        background: rgba(0,0,0,.75);
        color: #fff;
        font-size: 12px;
        padding: 4px 10px;
        border-radius: 999px;
        white-space: nowrap;
        pointer-events: none;
      }

      /* Close button */
      .gallery--close-button {
        width: 40px;
        height: 40px;
        border-radius: 999px;

        background-color: #F4B13D;
        background-image: url('data:image/svg+xml;utf8,<svg viewBox="0 0 329 329" xmlns="http://www.w3.org/2000/svg" fill="black"><path d="M194.8 164.8 323 36.6c8.3-8.3 8.3-21.8 0-30.2-8.3-8.3-21.8-8.3-30.2 0L164.6 134.6 36.4 6.4c-8.3-8.3-21.8-8.3-30.2 0-8.3 8.3-8.3 21.8 0 30.2l128.2 128.2L6.2 293c-8.3 8.3-8.3 21.8 0 30.2 4.2 4.2 9.6 6.3 15.1 6.3 5.5 0 10.9-2.1 15.1-6.3l128.2-128.2 128.2 128.2c4.2 4.2 9.6 6.3 15.1 6.3 5.5 0 10.9-2.1 15.1-6.3 8.3-8.3 8.3-21.8 0-30.2z"/></svg>');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 14px 14px;

        position: fixed;
        right: 16px;
        top: calc(var(--sticky-header-height, 0px) + 14px);

        box-shadow: 0 4px 10px rgba(0,0,0,.25);
        cursor: pointer;

        display: none;
        z-index: 1001;
      }

      body.gallery--sticky-active .gallery--close-button {
        display: block;
      }

      body.gallery--sticky-active {
        overflow-x: clip;
      }

     /* Keep TeeInBlue canvas sizing (e.g., 400px) but scale it to fit screen */
body.gallery--sticky-active .tee-gallery {
  /* scale = (viewport width - small gutters) / 400px, clamped so it never grows beyond 1 */
  --tee-base: 400;
  --tee-gutter: 24px;
  --tee-scale: clamp(0.7, calc((100vw - var(--tee-gutter)) / var(--tee-base)), 1);

  transform: scale(var(--tee-scale));
  transform-origin: top center;
  width: auto !important;
}

/* Ensure the canvas stays centered in the sticky bar */
body.gallery--sticky-active .tee-gallery-content {
  justify-content: center !important;
}

    `;
    document.head.appendChild(style);

    /* ------------------------------------------------------------
       3) UI creation
       ------------------------------------------------------------ */
    let hasUI = false;

    const ensureUI = () => {
      if (hasUI) return;

      const trigger = document.createElement("div");
      trigger.className = "sticky-gallery-trigger";

      const button = document.createElement("div");
      button.className = "sticky-gallery-button";

      const label = document.createElement("div");
      label.className = "sticky-gallery-label";
      const labelSource = document.getElementById("sticky-preview-label");
      label.textContent = labelSource ? labelSource.textContent.trim() : "";

      const close = document.createElement("div");
      close.className = "gallery--close-button";

      button.addEventListener("click", () => {
        document.body.classList.add("gallery--sticky-active");
        document.body.classList.add("gallery--sticky-enabled");

        const $content = document.querySelector(".tee-gallery-content");
        if (!$content) return;

        const headerOffset = getHeaderOffset();
        $galleryWrapper.style.height = `${$content.offsetHeight + headerOffset + 10}px`;
      });

      close.addEventListener("click", () => {
        document.body.classList.remove("gallery--sticky-active");
        $galleryWrapper.style.removeProperty("height");
      });

      trigger.appendChild(button);
      trigger.appendChild(label);

      document.body.appendChild(trigger);
      document.body.appendChild(close);

      hasUI = true;
    };

    /* ------------------------------------------------------------
       4) State sync
       - If NOT active: enable/disable feature based on form position (as before)
       - If active: keep it enabled and open even beyond the form
       ------------------------------------------------------------ */
    let ticking = false;

    const compute = () => {
      ticking = false;

      const $form = document.getElementById("tee-artwork-form");
      const $content = document.querySelector(".tee-gallery-content");
      if (!$form || !$content) return;

      ensureUI();

      const headerOffset = getHeaderOffset();
      const contentHeight = $content.offsetHeight;
      const formBottom = $form.getBoundingClientRect().bottom;

      const isActive = document.body.classList.contains("gallery--sticky-active");
      const canEnable = formBottom > contentHeight;

      if (isActive) {
        // User explicitly opened sticky: keep it open regardless of form position.
        document.body.classList.add("gallery--sticky-enabled");
        $galleryWrapper.style.height = `${contentHeight + headerOffset + 10}px`;
        return;
      }

      // Not active: only show the “Keep visible” control while it makes sense.
      if (canEnable) {
        document.body.classList.add("gallery--sticky-enabled");
      } else {
        document.body.classList.remove("gallery--sticky-enabled");
        $galleryWrapper.style.removeProperty("height");
      }
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(compute);
      }
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);

    /* ------------------------------------------------------------
       5) Enable feature on entry (but do NOT activate sticky)
       ------------------------------------------------------------ */
    document.body.classList.add("gallery--sticky-enabled");
    compute();
  };

  const w = window.innerWidth;
  const h = window.innerHeight;

  if (h / w > 1.5 && w < 768) {
    setTimeout(fixedLivePreview, 2000);
  }
});
